import React from "react";
import { faqs, agency } from "../mock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
        <div>
          <span className="eyebrow-line text-accent tracking-[0.3em] text-xs font-medium uppercase">Questions fréquentes</span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-5 text-foreground">Vos questions, nos réponses</h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Une question qui n'est pas listée ? Appelez-nous au{" "}
            <a href={`tel:${agency.phoneHref}`} data-testid="faq-phone-link" className="text-accent font-medium hover:underline">{agency.phone}</a>.
          </p>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-border">
              <AccordionTrigger data-testid={`faq-question-${i}`} className="font-serif text-lg text-left text-foreground hover:text-accent hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-muted-foreground text-[15px] leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
